module.exports = __webpack_public_path__ + "static/media/head-vr.ce8719e8.svg";